"use client";
import React from "react";
import { Drawer } from "antd";
import RequestForm from "./ServiceRequestForm";
import type {
  ConsultationService,
  ServiceRequestPayload,
} from "./ServiceRequestForm";
import type { MediaUploadFn } from "./ServiceRequestForm/Uploader";
import type { ScheduleSummary } from "./LocationStep";

/**
 * Shared consultation request drawer.
 *
 * Wraps ServiceRequestForm in an Ant Drawer. Used by both member-mode and
 * schedule-mode booking when services require consultation.
 */
export default function ConsultationDrawer({
  salonId,
  userId,
  teamMemberId,
  scheduleId,
  scheduleOptions,
  services,
  open,
  onClose,
  submitRequest,
  uploadMedia,
}: {
  salonId: string;
  userId?: string;
  teamMemberId?: string;
  scheduleId?: string;
  scheduleOptions?: ScheduleSummary[];
  services: ConsultationService[];
  open: boolean;
  onClose: () => void;
  submitRequest: (payload: ServiceRequestPayload) => Promise<void>;
  uploadMedia: MediaUploadFn;
}) {
  return (
    <Drawer
      destroyOnClose
      title="Service request"
      onClose={onClose}
      open={open}
      styles={{ wrapper: { width: 480 } }}
      // Portals to document.body, outside any themed root's inline vars.
      // The booking theme re-scopes its skin vars to this class; inert
      // wherever no theme root is present (e.g. template pages).
      rootClassName="openings-booking-portal"
    >
      <RequestForm
        salonId={salonId}
        userId={userId}
        teamMemberId={teamMemberId}
        scheduleId={scheduleId}
        scheduleOptions={scheduleOptions}
        services={services}
        onClose={onClose}
        submitRequest={submitRequest}
        uploadMedia={uploadMedia}
      />
    </Drawer>
  );
}

export type { ConsultationService, ServiceRequestPayload };
